import { Policy } from "@repo/api/schemas/policies.schema";
import { IntlShape, defineMessages } from "react-intl";

const messages = defineMessages({
  clone: {
    defaultMessage: "Clone",
    id: "ZJj9fQ",
    description: "Tooltip text for clone button in policy list page kebab menu",
  },
  disable: {
    defaultMessage: "Disable",
    id: "UPq5sn",
    description: "Disable option in policy list page kebab menu",
  },
  enable: {
    defaultMessage: "Enable",
    id: "XBChAZ",
    description: "Enable option in policy list page kebab menu",
  },
  edit: {
    defaultMessage: "Edit",
    id: "AoNluD",
    description: "Edit option in policy list page kebab menu",
  },
  delete: {
    defaultMessage: "Delete",
    id: "o+m0ox",
    description: "Delete option in policy list page kebab menu",
  },
});

const KEBAB_MENU_ITEMS = [
  { value: "clone", icon: "Copy", message: messages.clone },
  { value: "disable", icon: "CloseCircle", message: messages.disable },
  { value: "enable", icon: "Activate", message: messages.enable },
  { value: "edit", icon: "Edit", message: messages.edit },
  { value: "delete", icon: "Delete", message: messages.delete },
] as const;

export const getKebabMenuList = ({
  intl,
  rowData,
}: {
  intl: IntlShape;
  rowData: Policy;
}) => {
  const { is_active, is_custom, rule_definition } = rowData;
  const { processor, evaluationCriteria, query } = rule_definition;

  const excludeValues = new Set([
    is_active ? "enable" : "disable",
    ...(!is_custom ? ["edit", "delete"] : []),
  ]);

  /** Checks if the rule definition has no processor, evaluationCriteria, or query configured. */
  const isRuleDefinitionEmpty = !processor && !evaluationCriteria && !query;

  /** Exclude clone option when rule definition has no configuration to copy. */
  if (isRuleDefinitionEmpty) {
    excludeValues.add("clone");
  }
  return KEBAB_MENU_ITEMS.filter(({ value }) => !excludeValues.has(value)).map(
    ({ message, ...rest }) => ({ ...rest, label: intl.formatMessage(message) }),
  );
};
